<template>
  <div class="flex-col page">
    <span class="self-start text">相册</span>
    <div class="flex-row equal-division">
      <div class="flex-col section equal-division-item" @click="$router.push({name: 'jianjiwancheng'})">
        <div class="flex-col justify-start self-stretch relative section_2">
          <div class="shrink-0 section_3"></div>
          <div class="flex-col justify-start items-center text-wrapper pos">
            <span class="font text_2">保险科普</span>
          </div>
        </div>
        <span class="mt-6 self-center font_2 text_3">最新：2024年学平险保障范围全面扩大</span>
      </div>
      <div class="ml-16 flex-col section equal-division-item">
        <div class="flex-col justify-start self-stretch relative section_4">
          <div class="shrink-0 section_5"></div>
          <div class="flex-col justify-start items-center text-wrapper pos_2"><span class="font">保险科普</span></div>
        </div>
        <span class="mt-6 self-center font_2 text_3">一个保险条款的前世今生，看完秒懂</span>
      </div>
    </div>

    <div class="flex-row self-stretch relative bottom">
      <div class="section_10"></div>
      <div class="flex-col shrink-0 section_12 pos_6">
        <div class="flex-row justify-between">
          <img
            @click="$router.push('/shouye')"
            class="image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=599f1a3f7b185b6144b6fffae0e7851f.png"
          />
          <img
            @click="$router.push('/xiangce')"
            class="image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=bdb31a59b34e649dd7cbbb0b270c903d.png"
          />
          <img
            @click="$router.push('/wode')"
            class="image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=0a46c269bca69f2c4e3e6be4818af774.png"
          />
        </div>
        <div class="mt-4 flex-row justify-between">
          <span class="font_5 text_13">主页</span>
          <span class="font_5">相册</span>
          <span class="font_5">我的</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {};
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .page {
    padding: 37px 24px 30px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .text {
      margin-left: 4px;
      color: rgb(85, 239, 227);
      font-size: 24px;
      font-family: Barlow;
      font-weight: 600;
      line-height: 22.5px;
    }
    .equal-division {
      align-self: stretch;
      margin-top: 38px;
      .section {
        flex: 1 1 163px;
        .section_2 {
          border-radius: 16px;
          overflow: hidden;
          background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=638ec57cdd12efd957dd066c6b818f53.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .section_3 {
            border-radius: 16px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=638ec57cdd12efd957dd066c6b818f53.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            height: 204px;
          }
          .pos {
            position: absolute;
            left: 12px;
            top: 168px;
          }
        }
        .font_2 {
          font-size: 16px;
          font-family: Barlow;
          line-height: 24px;
          color: rgb(255, 255, 255);
        }
        .text_3 {
          width: 150px;
        }
        .section_4 {
          border-radius: 16px;
          overflow: hidden;
          background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=bf3dccebd9b9f7bd110ea9c97f55f49e.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          .section_5 {
            border-radius: 16px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=bf3dccebd9b9f7bd110ea9c97f55f49e.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            height: 204px;
          }
          .pos_2 {
            position: absolute;
            left: 12px;
            top: 168px;
          }
        }
        .text-wrapper {
          padding: 4px 0 8px;
          background-color: rgb(85, 239, 227);
          border-radius: 8px;
          width: 64px;
          .font {
            font-size: 12px;
            font-family: Barlow;
            line-height: 11px;
            color: rgb(17, 17, 17);
          }
          .text_2 {
            line-height: 11px;
          }
        }
      }
      .equal-division-item {
        padding-bottom: 18px;
        background-color: rgba(255, 255, 255, 0.05);
        border-radius: 16px;
        overflow: hidden;
        height: 276px;
      }
    }
    .equal-division_2 {
      position: relative;
      align-self: stretch;
      margin: 383px 26px 0;
      .group {
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        .text_4 {
          line-height: 9px;
        }
      }
      .equal-division-item_2 {
        padding: 4px 0;
        width: 92.5px;
        .text_5 {
          color: rgb(46, 5, 5);
        }
      }
      .image {
        width: 25px;
        height: 25px;
      }
      .font_3 {
        font-size: 10px;
        font-family: Nunito;
        line-height: 9px;
        color: rgb(166, 166, 166);
        margin-top: 2px;
      }
      .group_2 {
        position: absolute;
        right: 6.5px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .bottom {
      position: fixed;
      bottom: -76px;
      .section_10 {
        flex: 1 1 163px;
        border-radius: 16px;
        overflow: hidden;
        height: 204px;
      }
      .section_11 {
        margin-left: 16px;
        margin-right: 20px;
        flex: 1 1 163px;
        background-color: rgba(255, 255, 255, 0.05);
        border-radius: 16px 16px 0 0;
        overflow: hidden;
        height: 204px;
        .image-wrapper {
          border-radius: 16px;
          overflow: hidden;
          background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=8d77d3e05f086dca95b84a4b56e9e0de.png');
          background-position: 0% 0%;
          background-size: 100%, 100%;
          background-repeat: no-repeat;
          .image_3 {
            width: 162px;
            height: 204px;
          }
        }
      }
      .image_2 {
        border-radius: 16px;
        overflow: hidden;
        background-color: rgba(255, 255, 255, 0.05);
        width: 163px;
        height: 204px;
      }
      .pos_5 {
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .section_12 {
        padding: 8px 40px 12px;
        background-color: rgb(255, 255, 255);
        border-radius: 32px;
        filter: drop-shadow(-2px 4px 2px #8c8c8c26);
        width: 289px;
        .image_4 {
          width: 24px;
          height: 24px;
        }
        .font_5 {
          font-size: 10px;
          font-family: Nunito;
          line-height: 9px;
          color: rgb(166, 166, 166);
        }
        .text_13 {
          color: rgb(46, 5, 5);
          line-height: 9px;
        }
      }
      .pos_6 {
        position: absolute;
        left: 26.5px;
        top: 41px;
      }
    }
    .section_6 {
      padding: 2px 6px 8px;
      background-color: rgb(255, 255, 255);
      border-radius: 32px;
      filter: drop-shadow(-2px 4px 2px #8c8c8c26);
    }
  }
</style>
